/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FormGroup } from '@angular/forms';
import { getControl, traverseControlTree } from '@gh/core-ui';
import { isNotNil } from '@gh/core-util';
import { constant, forEach, includes, isNil, mapValues } from 'lodash';
import { AppFormGroup, toAppFormControl, toAppFormGroup } from './controls';
import { AppControl } from './controls/app-control';
import { FormAndName, FormState } from './form-state';

export function getFormStatePath(forms: FormAndName[]): string[] {
  return forms.slice(1).map((form) => form.name);
}

export function updatePrivilegedControls(form: FormState<any>, entryPoint: string): void {
  traverseControlTree(form.group, (child) => {
    const control = <AppControl>child;

    if (control.privilegedEntryPoint && includes(control.privilegedEntryPoint, entryPoint)) {
      control.updateSchema({});
    }
  });
}

export function updateAllPrivilegedControls(form: FormState<any>): void {
  traverseControlTree(form.group, (child) => {
    const control = <AppControl>child;

    if (control.privilegedEntryPoint) {
      control.updateSchema({});
    }
  });

  forEach(form.childForms, (formAndName) => updateAllPrivilegedControls(formAndName.form));
}

export function resetPrivilegedTokens(form: FormState<any>): void {
  const privilegedTokens = <FormGroup>form.group.get('privilegedTokens');

  if (privilegedTokens) {
    privilegedTokens.setValue(mapValues(privilegedTokens.controls, constant(null)));
  }

  forEach(form.childForms, (formAndName) => resetPrivilegedTokens(formAndName.form));
}

export function resetPrivilegedTokensAndUpdate(form: FormState<any>): void {
  resetPrivilegedTokens(form);
  updateAllPrivilegedControls(form);
}

export function isPrivilegedOperationAllowed(form: FormState<any>, entryPoint: string): boolean {
  const privilegedGroup: AppFormGroup = toAppFormGroup(getControl(form.group, `privilegedTokens`));
  const epControl = privilegedGroup.get(entryPoint);
  if (isNil(epControl)) {
    return true;
  }

  const privilegedControl: AppControl = toAppFormControl(epControl);
  // 1. Privileged control is not visible for corporate or master view
  // 2. Privileged control has value when token has been already received
  return !privilegedControl.visible || isNotNil(privilegedControl.value);
}
